export default Object.freeze({
  SUPERADMIN: 'administrator',
  PIC: 'ormas',
  KESBANGPOL: 'kesbangpol',
  POLPUM: 'admin_polpum',
  DEFAULT: 'default',
  ASING: 'admin_ormas_asing'
})
